import { EndpointModulesController } from '../controller/EndpointModulesController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class EndpointModulesWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EndpointModulesController,
    });
  }
}
